module.exports = __webpack_public_path__ + "static/img/AI感知与协同联动.c019a385.png";